import styled from "styled-components";

export const SelectAllNoneContainer = styled.div`
  display: flex;
  margin-top: -5px;
  margin-bottom: 10px;
  cursor: default !important;
`;

export const CheckboxesContainer = styled.div`
  display: flex;
  div {
    margin-top: 10px;
    margin-right: 10px;
  }

  .c-checkbox:hover em {
    border-color: red !important;
  }
`;

export const SelectStatusCheckboxes = styled.div`
  background-color: #ffffff;
  border: 0;
  cursor: pointer;
  color: lightskyblue;
  text-decoration: underline;
`;

export const DisplaySecondaryLabel = styled.span`
  margin-left: 10px;
  font-weight: 700;
`;

export const LabelWrapper = styled.span`
  display: inline-block;
  cursor: pointer;
  margin: 0 10px 5px 0;
`;

export const CheckboxContentWrapper = styled.div`
  cursor: default !important;
`;

export const MultiCheckboxContainer = styled.div`
  display: ${({ horizontal }: any) => (horizontal ? "flex" : "inherit")};
`;
